import { RequestError } from '@/common/types_and_interfaces.ts'

export const static_errors = {
  vital_parsing_error:
    'There was an error while reading the response to your request, please contact support.',
  unexpected_contact_support:
    'An unexpected error occurred. Please contact support if this occurs again.',
} as const

export const global_error_codes = {
  ocr_bc_many_attempts: 33,
  ocr_bc_more_than_18_years: 36,
  ocr_bc_more_than_21_years: 37,
  ocr_bc_multiple_errors: 76,
  invitation_expired: 23,
  external_service_error: 82,
  file_size_limit_exceeded: 113,
  file_type_not_allowed: 83,
  v1_registration_guard: 121,
} as const

export const Status = {
  Active: 1,
  Inactive: 0,
  Yes: 1,
  No: 0,
} as const

export const usStates = [
  { abbreviation: 'AL', name: 'Alabama' },
  { abbreviation: 'AK', name: 'Alaska' },
  { abbreviation: 'AZ', name: 'Arizona' },
  { abbreviation: 'AR', name: 'Arkansas' },
  { abbreviation: 'CA', name: 'California' },
  { abbreviation: 'CO', name: 'Colorado' },
  { abbreviation: 'CT', name: 'Connecticut' },
  { abbreviation: 'DE', name: 'Delaware' },
  { abbreviation: 'FL', name: 'Florida' },
  { abbreviation: 'GA', name: 'Georgia' },
  { abbreviation: 'HI', name: 'Hawaii' },
  { abbreviation: 'ID', name: 'Idaho' },
  { abbreviation: 'IL', name: 'Illinois' },
  { abbreviation: 'IN', name: 'Indiana' },
  { abbreviation: 'IA', name: 'Iowa' },
  { abbreviation: 'KS', name: 'Kansas' },
  { abbreviation: 'KY', name: 'Kentucky' },
  { abbreviation: 'LA', name: 'Louisiana' },
  { abbreviation: 'ME', name: 'Maine' },
  { abbreviation: 'MD', name: 'Maryland' },
  { abbreviation: 'MA', name: 'Massachusetts' },
  { abbreviation: 'MI', name: 'Michigan' },
  { abbreviation: 'MN', name: 'Minnesota' },
  { abbreviation: 'MS', name: 'Mississippi' },
  { abbreviation: 'MO', name: 'Missouri' },
  { abbreviation: 'MT', name: 'Montana' },
  { abbreviation: 'NE', name: 'Nebraska' },
  { abbreviation: 'NV', name: 'Nevada' },
  { abbreviation: 'NH', name: 'New Hampshire' },
  { abbreviation: 'NJ', name: 'New Jersey' },
  { abbreviation: 'NM', name: 'New Mexico' },
  { abbreviation: 'NY', name: 'New York' },
  { abbreviation: 'NC', name: 'North Carolina' },
  { abbreviation: 'ND', name: 'North Dakota' },
  { abbreviation: 'OH', name: 'Ohio' },
  { abbreviation: 'OK', name: 'Oklahoma' },
  { abbreviation: 'OR', name: 'Oregon' },
  { abbreviation: 'PA', name: 'Pennsylvania' },
  { abbreviation: 'RI', name: 'Rhode Island' },
  { abbreviation: 'SC', name: 'South Carolina' },
  { abbreviation: 'SD', name: 'South Dakota' },
  { abbreviation: 'TN', name: 'Tennessee' },
  { abbreviation: 'TX', name: 'Texas' },
  { abbreviation: 'UT', name: 'Utah' },
  { abbreviation: 'VT', name: 'Vermont' },
  { abbreviation: 'VA', name: 'Virginia' },
  { abbreviation: 'WA', name: 'Washington' },
  { abbreviation: 'WV', name: 'West Virginia' },
  { abbreviation: 'WI', name: 'Wisconsin' },
  { abbreviation: 'WY', name: 'Wyoming' },
] as const

export enum FETCH_STATUS {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

// These are all the registered subdomains for our dev websites
export const DEV_SUBDOMAIN = {
  WALLET: 'ace-wallet',
  VENDORS: 'ace-vendors',
  VENDORS_DEMO: 'ace-vendors-demo',
} as const

export const VALID_WALLET_SUBDOMAINS = [DEV_SUBDOMAIN.WALLET] as const
export type WalletSubdomain = (typeof VALID_WALLET_SUBDOMAINS)[number]
export const VALID_VENDORS_SUBDOMAINS = [
  DEV_SUBDOMAIN.VENDORS,
  DEV_SUBDOMAIN.VENDORS_DEMO,
] as const
export type VendorSubdomain = (typeof VALID_VENDORS_SUBDOMAINS)[number]

export const REGISTERED_SUBDOMAINS = [
  ...VALID_WALLET_SUBDOMAINS,
  ...VALID_VENDORS_SUBDOMAINS,
] as const

export type RegisteredSubdomain = WalletSubdomain & VendorSubdomain

export const ENV = { ...import.meta.env } as const

export const AppEnv = (env: 'production' | 'development') => {
  return ENV.MODE === env
}

export const INITIAL_ERROR: RequestError = {
  code: -3,
  message: '',
  details: null,
}

// This is scholarship_applications.status
export const STATUS_AGE_PHASE_OUT = 12

// this is the appeal_details we use to fetch all states in the united states
export const US_STATES_ID = 3

// https://www.w3schools.com/mysql/mysql_dates.asp
export const BASE_DATE_FORMAT = 'yyyy-MM-dd'
export const BASE_DATE_FORMAT_WITH_TIME = `${BASE_DATE_FORMAT} h:mm a`

// export const PLACEHOLDER_EMAIL = 'user@ufascholarships.com'
export const PLACEHOLDER_EMAIL = 'user@gmail.com'

// ACE Scholarships Support Phone Number
export const CONTACT_PHONE_NUMBER = +19858003950
export const CONTACT_PHONE_NUMBER_FORMATTED =
  CONTACT_PHONE_NUMBER.toString().replace(
    /^1(\d{3})(\d{3})(\d{4})/,
    '($1) $2-$3'
  )

// ACE Scholarships Support Email
export const CONTACT_EMAIL = 'support@acescholarships.org'

// ACE Scholarships Terms and Conditions
export const TERMS_AND_CONDITIONS_URL =
  'https://www.acescholarships.org/terms-and-conditions'
